<script lang="ts" setup>
import { ElNotification } from 'element-plus'
import Cookies from 'js-cookie'
import { computed, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'

const { setupIntentId } = defineProps<{
  setupIntentId: string
}>()

const store = useStore()
const router = useRouter()

const paymentError = computed(() => store.getters['payment/error'])
const isPaymentPaid = computed(() => store.getters['payment/isPaymentPaid'])
const shop = computed(() => store.getters['shop/shop'])

watchEffect(() => {
  void store.dispatch('payment/confirmPayment', { advertiserId: shop.value.id, setupIntentId })
})
watchEffect(() => {
  if (isPaymentPaid.value) {
    Cookies.remove('store_info')
    void store.dispatch('shop/fetchShop')
    void router.replace('/')
  }
})
watchEffect(() => {
  if (paymentError.value) {
    const e = paymentError.value
    const message = typeof e === 'string' ? e : 'message' in e ? e.message : 'Oops! Something went wrong.'
    ElNotification.error({
      message,
      duration: 0,
    })
    void router.replace('/onboarding')
  }
})
</script>
<template>
  <FlexComponent flex="1" justify="center" class="loading-spinner--container">
    <img width="75px" src="@/assets/loading.svg" alt="loading" class="loading-spinner" />
  </FlexComponent>
</template>
